module.exports = __webpack_public_path__ + "img/visuel-luneville.3a0be14.png";